/**
 * Countdown for the "Selling out fast" block. It counts down to the real end date in data-ends and hides the
 * whole block once that moment has passed. Nothing is stored, so the timer never restarts for a visitor.
 */

const BLOCK = '.scarcity';

/** @param {number} value */
const pad = (value) => String(value).padStart(2, '0');

const STORAGE_KEY = 'plum-scarcity-start';

/** TEST ONLY: personal start moment, remembered in this browser. */
function personalStart() {
  try {
    if (new URLSearchParams(window.location.search).has('reset-timer')) localStorage.removeItem(STORAGE_KEY);

    const saved = Number(localStorage.getItem(STORAGE_KEY));
    if (Number.isFinite(saved) && saved > 0) return saved;

    const start = Date.now();
    localStorage.setItem(STORAGE_KEY, String(start));
    return start;
  } catch {
    return Date.now();
  }
}

let startedAt = null;

/** @param {HTMLElement} block */
function endOf(block) {
  if (block.dataset.mode === 'per_visitor') {
    startedAt ??= personalStart();
    return startedAt + Number(block.dataset.duration ?? 0) * 1000;
  }

  return Date.parse(block.dataset.ends ?? '');
}

function tick() {
  const now = Date.now();

  document.querySelectorAll(BLOCK).forEach((block) => {
    if (!(block instanceof HTMLElement)) return;

    // Follows the sale of the announcement bar: same end date, only the countdown line hides when it is over.
    if (block.dataset.timer === 'sale') {
      block.hidden = false;
      const line = block.querySelector('.scarcity__timer');
      const saleEnd = Date.parse(document.querySelector('.pa__countdown')?.getAttribute('data-end') ?? '');
      const left = saleEnd - now;
      if (!(line instanceof HTMLElement)) return;
      if (!Number.isFinite(saleEnd) || left <= 0) {
        line.hidden = true;
        return;
      }
      line.hidden = false;
      const total = Math.floor(left / 1000);
      const days = Math.floor(total / 86400);
      const clock = `${pad(Math.floor((total % 86400) / 3600))}:${pad(Math.floor((total % 3600) / 60))}:${pad(total % 60)}`;
      const time = block.querySelector('.scarcity__time');
      if (time) time.textContent = days > 0 ? `${days}d ${clock}` : clock;
      return;
    }

    const end = endOf(block);
    const remaining = end - now;

    if (!Number.isFinite(end) || remaining <= 0) {
      block.hidden = true;
      return;
    }

    block.hidden = false;
    // Always hours:minutes:seconds. More than a day left simply shows more than 24 hours (no "10d").
    const totalSeconds = Math.floor(remaining / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const time = block.querySelector('.scarcity__time');
    if (time) time.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  });
}

tick();
setInterval(tick, 1000);
